<template>
  <div>
    <!-- Modal for displaying generic info messages to the user -->
    <BModal
      id="generic-info-popup"
      v-model="showGenericInfoModal"
      size="lg"
      @close="genericInfoModalHelper.closeGenericInfoModal()"
      @hide="genericInfoModalHelper.closeGenericInfoModal()"
      @cancel="genericInfoModalHelper.closeGenericInfoModal()"
    >
      <template #title>
        <header
          id="info-header"
          class="secondary-heading"
        >
          {{ header }}
        </header>
      </template>

      <div class="d-block text-center main-text-container">
        <p>
          {{ message }}
        </p>
      </div>

      <template #footer>
        <div class="input-container">
          <button
            type="button"
            class="default-button close-btn btn"
            @click="genericInfoModalHelper.closeGenericInfoModal()"
          >
            {{ $t('close') }}
          </button>
        </div>
      </template>
    </BModal>
  </div>
</template>

<script setup lang="ts">
import genericInfoModalHelper from '@/helperScripts/modalHelpers/genericInfoModalHelper';
import { useGeneralFlagStore } from '@/stores/generalFlagStore';
import { storeToRefs } from 'pinia';

withDefaults(defineProps<{ header?: string; message: string }>(), {
  header: '',
});

const { showGenericInfoModal } = storeToRefs(useGeneralFlagStore());
</script>

<style scoped lang="scss">
@import '@/scss/__variables.scss';

.close-btn {
  background-color: $button-green;
  border-color: $button-green;
  box-shadow: none;
}

.close-btn:hover {
  background-color: $button-hover-green;
  border-color: $button-hover-green;
  color: white;
}

.input-container {
  width: 100%;
  display: flex;
  justify-content: center;
}

.main-text-container {
  * {
    text-align: start;
  }
}
</style>
